/**
 * @flow
 * @relayHash a0a8fd45e59086b4dcac9f5038bbc1ed
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Resource = "ACC" | "ACTIVITY" | "ADVISER" | "APP" | "BANK_ACCT" | "INFO" | "PERF" | "PERM" | "PRICING" | "REPORTS" | "TENANT" | "TRANS" | "VUE" | "%future added value";
export type Scope = "DEEP" | "SELF" | "TENANT" | "%future added value";
export type Verb = "MUTATE" | "READ" | "%future added value";
export type AdviserPermissionInput = {|
  resource?: ?Resource,
  verb?: ?Verb,
  scope?: ?Scope,
|};
export type CreateAdviserRoleMutationVariables = {|
  name: string,
  defaultPermissions?: ?string,
  rolePermissions?: ?$ReadOnlyArray<?AdviserPermissionInput>,
|};
export type CreateAdviserRoleMutationResponse = {|
  +createAdviserRole: ?{|
    +adviserRole: ?{|
      +id: string,
      +name: string,
      +rolePermissions: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +resource: Resource,
            +verb: Verb,
            +scope: Scope,
          |}
        |}>
      |},
    |}
  |}
|};
export type CreateAdviserRoleMutation = {|
  variables: CreateAdviserRoleMutationVariables,
  response: CreateAdviserRoleMutationResponse,
|};
*/


/*
mutation CreateAdviserRoleMutation(
  $name: String!
  $defaultPermissions: String
  $rolePermissions: [AdviserPermissionInput]
) {
  createAdviserRole(name: $name, defaultPermissions: $defaultPermissions, rolePermissions: $rolePermissions) {
    adviserRole {
      id
      name
      rolePermissions {
        edges {
          node {
            id
            resource
            verb
            scope
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "defaultPermissions",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "rolePermissions",
    "type": "[AdviserPermissionInput]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createAdviserRole",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "defaultPermissions",
        "variableName": "defaultPermissions"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "rolePermissions",
        "variableName": "rolePermissions"
      }
    ],
    "concreteType": "CreateAdviserRole",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "adviserRole",
        "storageKey": null,
        "args": null,
        "concreteType": "AdviserRoleNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "rolePermissions",
            "storageKey": null,
            "args": null,
            "concreteType": "AdviserRolePermissionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "AdviserRolePermissionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AdviserRolePermissionNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "resource",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "verb",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "scope",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateAdviserRoleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateAdviserRoleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateAdviserRoleMutation",
    "id": null,
    "text": "mutation CreateAdviserRoleMutation(\n  $name: String!\n  $defaultPermissions: String\n  $rolePermissions: [AdviserPermissionInput]\n) {\n  createAdviserRole(name: $name, defaultPermissions: $defaultPermissions, rolePermissions: $rolePermissions) {\n    adviserRole {\n      id\n      name\n      rolePermissions {\n        edges {\n          node {\n            id\n            resource\n            verb\n            scope\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd1fcc982a05490954b47c7f937795b87';
module.exports = node;
